<template>
  <div class="dialog-root">
    <div class="container">
      <avue-form ref="formRef" :option="formOption" v-model="formData">
        <template slot="attachList">
          <VUpload
            :fileList.sync="formData.attachList"
            :types="['jpg', 'png']"
            :disabled="dialogType == 'view'"
          />
        </template>
      </avue-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder" v-if="dialogType != 'view'"></div>
    <!-- 底部操作按钮 -->
    <div class="btn" v-if="dialogType != 'view'">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload';
import { getDetailApi, addApi, updateApi } from '@/api/general-manage/social-circle';

export default {
  props: ['dialogType', 'projectId', 'circleId'],
  components: {
    VUpload,
  },
  data() {
    return {
      communities: [], // 小区列表
      formData: {}, // 表单数据
    };
  },
  computed: {
    formOption() {
      let opt = {
        menuBtn: false,
        labelWidth: 100,
        column: [
          {
            label: '所属版块',
            prop: 'plateType',
            span: 12,
            disabled: this.dialogType == 'view',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=social_circle_plate_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            value: 0,
            dataType: 'number',
          },
          {
            label: '位置信息',
            prop: 'location',
            span: 12,
            disabled: this.dialogType == 'view',
            type: 'select',
            dicUrl: '/api/v4ward/out/order/service/community/list?projectId=' + this.projectId,
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '圈子内容',
            prop: 'content',
            disabled: this.dialogType == 'view',
            type: 'textarea',
            maxlength: 500,
            showWordLimit: true,
            minRows: 3,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入圈子内容',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '图片上传',
            prop: 'attachList',
            formslot: true,
            span: 24,
          },
        ],
      };
      if (this.dialogType == 'view') {
        let viewSpecialColumns = [
          {
            label: '圈子发布方',
            prop: 'userType',
            span: 12,
            disabled: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=social_circle_user_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '发布人',
            prop: 'publisherName',
            span: 12,
            disabled: true,
          },
        ];
        opt.column = viewSpecialColumns.concat(opt.column);
      }
      return opt;
    },
  },
  created() {
    if (this.dialogType == 'view' || this.dialogType == 'edit') {
      getDetailApi({
        id: this.circleId,
      }).then(({ data }) => {
        this.formData = data;
      });
    } else {
      this.formData.projectId = this.projectId;
      this.formData.attachList = [];
    }
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? addApi : updateApi;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
